import { render, staticRenderFns } from "./ManageAcademyEventPlus.vue?vue&type=template&id=40d380b7&scoped=true"
import script from "./ManageAcademyEventPlus.vue?vue&type=script&lang=js"
export * from "./ManageAcademyEventPlus.vue?vue&type=script&lang=js"
import style0 from "./ManageAcademyEventPlus.vue?vue&type=style&index=0&id=40d380b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d380b7",
  null
  
)

export default component.exports